





































import Vue from 'vue'
import { Progress } from 'element-ui'
import Queue from 'promise-queue'
import fb from '../../firebase'
import helpers from '../../helpers'
import './FileUploader.scss'

interface UploadFileAsset {
  name: string
  type: string
  url: string
  thumbnail?: string
  transcoded: boolean
  volume?: number
}

const queue = new Queue(1, 20)

export default Vue.extend({
  name: 'FileUploader',
  props: {
    teamId: {
      type: String
    },
    uploadType: {
      type: String
    }
  },
  computed: {
    acceptByType (): string {
      switch (this.uploadType) {
        case 'video':
          return '.mp4,.mov,.avi,.mkv'
        case 'stinger':
          return '.webm'
        case 'slate':
        case 'graphic':
        case 'background':
          return '.jpg,.jpeg,.png,.webm'
      }
      return '*'
    }
  },
  watch: {
    uploadsDone (newVal: boolean) {
      if (newVal) {
        this.uploading = false
        this.uploadEnd = false
        this.uploadsDone = false
        this.fileList = undefined
        this.$emit('uploadsComplete')
      }
    },
    uploadType: {
      handler (newUploadType: string) {
        this.detectUploadAction(newUploadType)
      },
      // immediate: true        // this caused the upload dialog in this.selectFile() to trigger twice
    }
  },
  data: () => ({
    progressUpload: 0,
    fileName: '',
    fileList: undefined as undefined | FileList,
    uploadTask: undefined as undefined | firebase.storage.UploadTask,
    uploading: false,
    uploadEnd: false,
    uploadsDone: false,
    downloadURL: '',
    numberComplete: 0,
    numberOfFiles: 0,
    currentFilepath: '',
    currentFilename: '',
    urlError: '',
    showURLPopup: false
  }),
  methods: {
    detectUploadAction (newUploadType: string) {
      if (!newUploadType) return

      switch (newUploadType) {
        case 'graphic':
        case 'video':
        case 'stinger': 
          this.selectFile(newUploadType)
          break
      }
    },
    selectFile (type: string) {
      console.warn('new upload type: ', type);
      setTimeout(() => {
        const input = this.$refs.uploadInput as undefined | HTMLInputElement
        if (input) input.click()
      }, 100)
    },
    detectFiles (event: Event) {
      this.$emit('uploadsStarted')
      if (event.target !== null) {
        const input = event.target as HTMLInputElement
        this.fileList = input.files !== null ? input.files : undefined
      }
      this.numberComplete = 0
      if (this.fileList === undefined) return
      this.numberOfFiles = this.fileList.length
      Array.from(Array(this.fileList.length).keys()).map(x => {
        // this.upload(this.fileList[x])
        queue.add(() => {
          if (this.fileList === undefined) return
          const file = this.fileList[x]
          return new Promise<void>(resolve => {
            this.progressUpload = 0
            this.uploadEnd = false
            this.fileName = file.name
            this.uploading = true
            this.currentFilename = file.name
            this.currentFilepath = this.teamId + '/' + this.teamId + '_' + helpers.makeId() + '_' + file.name.replace(/[^0-9a-z_. ]/gi, '')
            this.uploadTask = fb.firestorage.ref(this.currentFilepath).put(file)
            this.uploadTask.on('state_changed', sp => {
              this.progressUpload = Math.floor(sp.bytesTransferred / sp.totalBytes * 100)
            },
            error => {
              console.log(error)
            },
            () => {
              if (this.uploadTask === undefined) return
              this.uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
                this.uploadEnd = true
                this.numberComplete++
                this.uploadsDone = (this.numberComplete === this.numberOfFiles)
                const cleanFilename = this.fileName.replace(/[^0-9a-z_. ]/gi, '')
                const file: UploadFileAsset = {
                  name: cleanFilename,
                  type: this.uploadType,
                  url: downloadURL,
                  transcoded: false,
                }
                if (this.uploadType === 'video') {
                  file.volume = 100
                } else {
                  file.thumbnail = downloadURL
                }
                this.$emit('fileUploaded', file)
                resolve()
              }).catch(error => {
                console.error('Could not get the download url of the uploaded asset', error)
              })
            })
          })
        })
      })
    },
    closeUpload () {
      this.$emit('closeUpload')
    }
  },
  components: {
    'el-progress': Progress
  }
})
